module.exports = __webpack_public_path__ + "static/media/38_B.9f4882ed.png";